export default (px, context = 16) => `${(px / context).toFixed(3)}em`;



// WEBPACK FOOTER //
// ./src/styles/pxToEm.js